import { render, staticRenderFns } from "./nav-bar-product.vue?vue&type=template&id=10047669"
import script from "./nav-bar-product.vue?vue&type=script&lang=js"
export * from "./nav-bar-product.vue?vue&type=script&lang=js"
import style0 from "./nav-bar-product.vue?vue&type=style&index=0&id=10047669&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports